// Menú desplegable de "Packs" (como el "SHOP" de SULT, 2026-10-13): se abre al pasar el mouse o con el teclado,
// se cierra al salir, con Esc o al bajar la página. Solo compu (en celular está el menú hamburguesa).
(function () {
  const bar = document.querySelector('.topbar'), nav = bar && bar.querySelector('.nav');
  const link = nav && [...nav.querySelectorAll('a')].find(a => /^packs\b/i.test(a.textContent.trim()));
  if (!link) return;
  const T = { reishi: 'Reishi', melena: 'Melena de León', ashwa: 'Ashwagandha', ginseng: 'Ginseng', cordyceps: 'Cordyceps', oregano: 'Orégano' };
  const PRECIO = { 2: '$49.990', 3: '$76.990', 4: '$99.000', 6: '$149.990' };
  const PACKS = [
    ['calma', 'Calma & Descanso', ['reishi', 'ashwa']], ['enfoque', 'Enfoque & Claridad', ['melena', 'ginseng']],
    ['claridad', 'Claridad y Calma', ['melena', 'reishi']], ['femenino', 'Bienestar Femenino', ['ashwa', 'reishi', 'melena']],
    ['energia', 'Energía & Rendimiento', ['cordyceps', 'ginseng', 'ashwa']], ['defensas', 'Defensas & Bienestar', ['oregano', 'reishi', 'ginseng']],
    ['digestivo', 'Bienestar Digestivo', ['oregano', 'reishi', 'melena']], ['total', 'Equilibrio Total', ['ashwa', 'reishi', 'cordyceps', 'melena']],
    ['completo', 'Completo Mykora', ['reishi', 'melena', 'ashwa', 'ginseng', 'cordyceps', 'oregano']],
  ];
  const TINT = [['reishi', 'Noche'], ['ashwa', 'Tarde'], ['melena', 'Mañana'], ['ginseng', 'Mañana'], ['cordyceps', 'Antes de entrenar'], ['oregano', 'Con las comidas']];
  const esc = s => s.replace(/&/g, '&amp;');
  const fila = (href, img, n, d, p) => `<li><a class="mt-it" href="${href}"><img data-src="${img}" alt="" width="46" height="46" decoding="async"><span><span class="n">${esc(n)}</span><span class="d">${esc(d)}</span></span><span class="p">${p}</span></a></li>`;

  const panel = document.createElement('div');
  panel.className = 'mt'; panel.id = 'menu-tienda';
  panel.innerHTML = `<div class="mt-cols">
    <section class="mt-col" aria-label="Packs"><h2>Packs armados</h2><ul>${PACKS.map(([k, n, ts]) =>
      fila(MKP.pack[k], `${MKA}packs-pack-${k}-principal-v3-t.webp`, n, ts.length < 6 ? ts.map(t => T[t]).join(' + ') : 'Las 6 tinturas', PRECIO[ts.length])).join('')}</ul></section>
    <section class="mt-col" aria-label="Tinturas sueltas"><h2>Tinturas sueltas</h2><ul>${TINT.map(([t, m]) =>
      fila(MKP.t[t], `${MKA}frascos-${t}-mini.webp`, T[t], m, '$28.990')).join('')}</ul></section>
  </div>
  <div class="mt-pie"><a href="/collections/all">Ver toda la tienda <span aria-hidden="true">›</span></a><a class="club" href="${MKU.club}">En el Club, 10% menos cada mes</a></div>`;
  bar.appendChild(panel);
  link.classList.add('mt-gatillo');
  link.setAttribute('aria-controls', 'menu-tienda'); link.setAttribute('aria-expanded', 'false');

  const puede = matchMedia('(min-width:1000px)');
  let t = 0, abierto = false;
  function ubicar() {   // el panel arranca alineado con la pastilla de la barra
    const p = bar.querySelector('.pillnav').getBoundingClientRect(), b = bar.getBoundingClientRect();
    panel.style.left = (p.left - b.left) + 'px';
  }
  function abrir() {
    if (!puede.matches) return;
    clearTimeout(t); if (abierto) return;
    if (!panel.dataset.cargado) { panel.querySelectorAll('img[data-src]').forEach(i => { i.src = i.dataset.src; }); panel.dataset.cargado = 1; }   // las fotos se bajan recién la primera vez que se abre
    ubicar(); abierto = true; panel.classList.add('on'); link.setAttribute('aria-expanded', 'true'); bar.classList.remove('oculta');
  }
  function cerrar(ya) {
    clearTimeout(t);
    const fin = () => { abierto = false; panel.classList.remove('on'); link.setAttribute('aria-expanded', 'false'); };
    ya ? fin() : (t = setTimeout(fin, 160));
  }
  [link, panel].forEach(el => {
    el.addEventListener('pointerenter', e => { if (e.pointerType !== 'touch') abrir(); });
    el.addEventListener('pointerleave', e => { if (e.pointerType !== 'touch') cerrar(); });
  });
  // teclado: el foco en "Packs" lo abre; salir del link y del panel lo cierra; Esc vuelve a "Packs"
  link.addEventListener('focus', abrir);
  [link, panel].forEach(el => el.addEventListener('focusout', e => { if (!link.contains(e.relatedTarget) && !panel.contains(e.relatedTarget)) cerrar(true); }));
  link.addEventListener('keydown', e => { if (e.key === 'ArrowDown' && abierto) { e.preventDefault(); panel.querySelector('a').focus(); } });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && abierto) { const volver = panel.contains(document.activeElement); cerrar(true); if (volver) link.focus(); } });
  addEventListener('scroll', () => { if (abierto && !panel.matches(':hover')) cerrar(true); }, { passive: true });
  addEventListener('resize', () => abierto && ubicar());
})();
